import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import recordSlice from "./slices/recordSlice";
export const store = configureStore({
  reducer: {
    authSlice: authSlice,
    recordSlice: recordSlice,
  },
});
